import { FC } from 'react';
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';

import { Observation } from 'types';

import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

type ObservationsSectionTableRowProps = {
  index: number;
  observation: Observation;
};

const ObservationsSectionTableRow: FC<ObservationsSectionTableRowProps> = ({
  index,
  observation,
}) => {
  const cells = [
    {
      key: `observation-date-${index}`,
      content: format(new Date(observation.date), DATE_FORMAT_WITH_TIME),
      className: 'w-150px',
    },
    {
      key: `observation-status-${index}`,
      content: observation.status,
      className: 'w-150px',
    },
    {
      key: `observation-text-${index}`,
      content: observation.text,
    },
  ] as RowCell[];

  return <TableRow cells={cells} />;
};

export default ObservationsSectionTableRow;
